(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const link=event.target.closest('[data-cai-open-shipping]');
    if(!link)return;
    const panel=link.closest('[data-cai-product-inquiry]');
    const topic=panel.querySelector('[data-cai-inquiry-topic]');
    if(!topic)return;
    event.preventDefault();
    panel.querySelector('.cai-pi-details').open=true;
    topic.value='International shipping';
    panel.querySelector('[data-cai-shipping]').open=true;
    topic.focus();
  });
  document.addEventListener('change',function(event){
    if(!event.target.matches('[data-cai-inquiry-topic]'))return;
    event.target.closest('[data-cai-product-inquiry]').querySelector('[data-cai-shipping]').open=event.target.value==='International shipping';
  });
  } catch(e) { console.error(e); }
})();

})();
